import styled from 'styled-components';
import { spacing } from '_utils/props';
import { mq, svg, text_xscap, text_s } from '_utils/styles';
import { Image as SCImage } from '@sitecore-jss/sitecore-jss-react';

export const Container = styled.div`
  position: relative;
  width: 100%;
`;

export const Figure = styled.figure`
  width: 100%;
  margin: 0;
`;
export const Image = styled(SCImage)`
  width: 100%;
  height: auto;

  // limit width of placeholder
  &[data-empty='true'] {
    max-width: 450px;
  }
`;

export const Figcaption = styled.figcaption`
  display:flex;
  ${text_s}
  color: ${({ theme }) => theme.colors.element.quaternary};
  ${({ theme }) => spacing({ theme, $m: '8px 0' })};
`;

export const IconWrapper = styled.div`
  flex: 0 0 auto;
  padding: 2px 9px 0 0;
`;
export const Icon = styled.div`
  ${svg(16, 16)};
  width: 16px;
  path {
    fill: ${({ theme }) => theme.card.attributeIcon};
  }
`;

export const TextWrapper = styled.div`
  flex: 1 1 0px;

  p {
    margin-bottom: 0;
  }
  div {
    display: inline-block;
  }
`;
export const Title = styled.span`
  font-weight: bold;
`;

export const Credit = styled.span`
  ${text_xscap}
  margin: 0;
  padding: 0 0 0 6px;
  ${mq('md')} {
    padding: 0 0 0 6px;
  }
`;
